import { observer } from 'mobx-react-lite';
import React from 'react';

interface IToggleButtonProps {
  callback: () => void;
  title: string;
  flag: boolean;
  id: string;
  className?: string;
}

const ToggleButtonComponent = (props: IToggleButtonProps) => {
  return (
    <button
      className={`usa-button  ${props.flag ? 'usa-button--active' : 'usa-button--outline'} ${
        props.className ? props.className : ''
      }`}
      onClick={props.callback}
      id={props.id}
      name={props.id}
      data-testid={props.id}
    >
      {props.title}
    </button>
  );
};

export const ToggleButton = observer(ToggleButtonComponent);
